// Setup location cookie function
const COOKIE_NAME = "userSelectedLocation";
const CONFIRMATION_TEXT = "CHANGE LOCATION & CLEAR MY CART";
const LOCATIONS = {
  1: {
    elementId: "storeLocationOption-1",
    selectedText: "NEW HAMPSHIRE SELECTED",
  },
  2: {
    elementId: "storeLocationOption-2",
    selectedText: "TEXAS SELECTED",
  },
};

function updateLocationLabel(labelElement, isConfirmationState) {
  if (isConfirmationState) {
    labelElement.innerText = CONFIRMATION_TEXT;
    labelElement.style.backgroundColor = "red";
    labelElement.style.color = "white";
  }
}

function setLocationCookie(value) {
  document.cookie = `${COOKIE_NAME}=${value};domain=;path=/`;
}

function handleLocationSelection(locationNumber) {
  const locationConfig = LOCATIONS[locationNumber];
  const locationValue = document.getElementById(locationConfig.elementId).value;
  const labelElement = document.querySelector(
    `label[for="${locationConfig.elementId}"]`
  );
  const isInitialSelection = locationSet === "Not Selected";
  const isConfirmationClicked = labelElement.innerText === CONFIRMATION_TEXT;
  const isCurrentLocation =
    labelElement.innerText === locationConfig.selectedText;

  // If this is the user's first location selection
  if (isInitialSelection) {
    setLocationCookie(locationValue);
    location.reload();
    return;
  }

  // If user has confirmed the location change
  if (isConfirmationClicked) {
    setLocationCookie(locationValue);
    window.location.href = "/cart/clear";
    console.log("Cart Cleared");
    return;
  }

  // Show confirmation state if not currently selected location
  if (!isCurrentLocation) {
    updateLocationLabel(labelElement, true);
    console.log("Cart Confirm");
  }
}

// Event handler functions
function handleLocation1() {
  handleLocationSelection(1);
}

function handleLocation2() {
  handleLocationSelection(2);
}

// Initialize
let locationSet = "Not Selected";
console.log(document.cookie);

// Clear location cookie button - Hidden
document.getElementById("clearCookies").addEventListener("click", function () {
  // Remove the 'userSelectedLocation' cookie by setting its expiration date to the past
  document.cookie =
    "userSelectedLocation=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  window.location.href = "/cart/clear";
  console.log("Cart Cleared");
  // location.reload();
});

// Primary logic for store-based add to cart functionality
window.onload = function () {
  setTimeout(function () {
    console.log("=== Starting location check ===");
    const name = "userSelectedLocation=";

    // Only continue with location checks if product is in stock somewhere
    if (document.cookie.length !== 0) {
      const cDecoded = decodeURIComponent(document.cookie);
      console.log("Checking cookies:", cDecoded);

      const cArr = cDecoded.split("; ");
      let selectedStore = "";

      cArr.forEach(function (val) {
        if (val.indexOf(name) === 0) {
          locationSet = "Selected";
          selectedStore = val.substring(name.length);
          console.log("Found selected store:", selectedStore);
        }
      });

      // Handle Texas Location
      if (selectedStore === "Texas") {
        console.log("Processing Texas store logic");

        const storeLocationOption2 = document.getElementById(
          "storeLocationOption-2"
        );
        const storeLocationOption2Label = document.querySelector(
          'label[for="storeLocationOption-2"]'
        );

        if (storeLocationOption2 && storeLocationOption2Label) {
          storeLocationOption2.checked = true;
          storeLocationOption2Label.innerText = "TEXAS SELECTED";
          storeLocationOption2Label.style.backgroundColor =
            "rgb(245, 245, 245)";
        }

        const storeAvailabilityIconButtons = document.querySelectorAll(
          ".store-availability-icon"
        );
        storeAvailabilityIconButtons.forEach(function (button) {
          const span = document.createElement("span");
          span.textContent = " TX";
          button.appendChild(span);
        });

      }

      // Handle New Hampshire Location
      if (selectedStore === "New Hampshire") {
        console.log("Processing New Hampshire store logic");

        const storeLocationOption1 = document.getElementById(
          "storeLocationOption-1"
        );
        const storeLocationOption1Label = document.querySelector(
          'label[for="storeLocationOption-1"]'
        );

        console.log("NH elements found:", {
          radio: !!storeLocationOption1,
          label: !!storeLocationOption1Label,
        });

        if (storeLocationOption1 && storeLocationOption1Label) {
          storeLocationOption1.checked = true;
          storeLocationOption1Label.innerText = "NEW HAMPSHIRE SELECTED";
          storeLocationOption1Label.style.backgroundColor =
            "rgb(245, 245, 245)";
        }

        const storeAvailabilityIconButtons = document.querySelectorAll(
          ".store-availability-icon"
        );
        storeAvailabilityIconButtons.forEach(function (button) {
          const span = document.createElement("span");
          span.textContent = " NH";
          button.appendChild(span);
        });
      }

      if (locationSet === "Not Selected") {
        console.log(
          "No location selected, setting up location selection buttons"
        );
        const originalAddToCartButton = document.getElementById("AddToCart");
        const stickyAddToCartButton =
          document.getElementById("StickyAddToCart");
        const buyButtonsElement = document.querySelector(
          ".product-form__buy-buttons"
        );

    }
}
  }, 600);

};


